import React from "react"
import styled from "styled-components"
import FooterBg from "../images/footer-background.svg"
import Leaf from "../images/pt-assets/leaf.png"
import Flora from "../images/Flora-Dark.svg"
import { fontWhite, mainLightGray, mainBlue } from "../styles"

const Footer = () => {
  return (
    <Wrapper>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h2>Ready to get started?</h2>
            <h4>
              Upon creating a Prime IRA, prospective investors must return to
              Flora Growth to complete an investment.
            </h4>
            <button>
              <a
                href="https://my.primetrust.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span className="d-flex align-items-center justify-content-center">
                  Open a Prime IRA
                  <img src={Leaf} alt="prime trust leaf" />
                </span>
              </a>
            </button>
            <button>
              <a
                href="https://www.investflora.com/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>
                  Invest in Flora <img src={Flora} alt="flora logo" />
                </span>
              </a>
            </button>
          </div>
        </div>
      </div>
    </Wrapper>
  )
}

const Wrapper = styled.footer`
  background-color: ${mainLightGray};
  background-image: url(${FooterBg});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  padding: 10rem 0 5rem 0;

  a {
    color: ${mainBlue};
    text-decoration: none;
  }
  h2 {
    text-align: center;
    color: ${fontWhite};
    font-size: 42px;
  }
  h4 {
    text-align: center;
    color: ${fontWhite};
    font-size: 30px !important;
    padding: 3rem 0 5rem 0;
  }

  button {
    margin: 2rem;
    padding: 1rem 2.5rem;
    width: 350px;
    background-color: ${mainLightGray};
    border: none;
    border-radius: 8px;
    font-size: 20px;
    color: ${mainBlue};

    img {
      height: 25px;
      margin: 0 0 0 0.75rem;
    }
  }

  @media screen and (max-width: 870px) {
    height: 100%;
    button {
      width: 100%;
      padding: 1rem 2rem;
      margin: 2rem auto;
    }
  }
`
export default Footer
